var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEuLogoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 94,
    viewBox: "0 0 333 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.628 10.5914H112.09V14.3228H118.161V16.6549H112.09V21.7856H118.628V24.1178H109.755V8.25928H118.628V10.5914Z",
    fill: "#2B2A29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.167 8.25928C127.035 8.25928 127.969 8.25928 128.903 9.19213C129.837 9.65856 130.771 10.5914 130.771 12.4571C130.771 13.39 130.771 14.7892 129.37 15.7221C131.239 16.1885 132.173 17.5878 132.173 19.4535C132.173 20.3864 132.173 21.7856 130.771 23.1849C129.37 24.1178 127.969 24.1178 126.568 24.1178H122.832V8.25928H125.167ZM125.167 15.2557H126.101C126.568 15.2557 128.436 15.2557 128.436 12.9235C128.436 10.5914 127.035 10.5914 126.101 10.5914H125.167V15.2557ZM125.167 21.7856H126.568C129.37 21.7856 129.837 20.3864 129.837 19.4535C129.837 18.5206 129.37 17.1214 126.568 17.1214H125.167V21.7856Z",
    fill: "#2B2A29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.178 8.25928C140.112 8.25928 141.513 8.25928 142.448 9.19213C143.849 10.125 144.783 11.5243 144.783 12.9235C144.783 13.8564 144.316 15.2557 142.915 16.6549C141.513 17.5878 140.112 17.5878 139.178 17.5878H137.777V24.1178H135.442V8.25928H139.178ZM137.777 15.2557H139.178C141.046 15.2557 141.98 14.3228 141.98 12.9235C141.98 11.9907 141.98 10.5914 139.178 10.5914H137.777V15.2557Z",
    fill: "#2B2A29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.464 16.1884C163.464 20.8527 160.195 24.5841 155.058 24.5841C150.387 24.5841 146.651 20.8527 146.651 16.1884C146.651 11.5241 150.387 7.79272 155.058 7.79272C160.195 7.79272 163.464 11.5241 163.464 16.1884ZM161.129 16.1884C161.129 12.457 158.794 10.1249 155.058 10.1249C151.788 10.1249 149.453 12.457 149.453 16.1884C149.453 19.9198 151.788 22.2519 155.058 22.2519C158.794 22.2519 161.129 19.9198 161.129 16.1884Z",
    fill: "#2B2A29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.409 8.25928V24.1178H176.074V10.5914H169.069V24.1178H166.733V8.25928H178.409Z",
    fill: "#2B2A29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.421 10.5914H185.882V14.3228H191.954V16.6549H185.882V21.7856H192.421V24.1178H183.547V8.25928H192.421V10.5914Z",
    fill: "#2B2A29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.366 13.39L196.624 25.0506V8.25927H198.959V18.9871L209.701 7.32642V24.1178H207.366V13.39Z",
    fill: "#2B2A29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.515 11.9906C225.114 10.1249 223.245 10.1249 222.311 10.1249C218.575 10.1249 216.24 12.9234 216.24 16.1884C216.24 19.9198 219.042 22.2519 222.311 22.2519C224.179 22.2519 225.581 21.3191 226.515 20.3862V23.6512C225.114 24.5841 223.245 24.5841 222.311 24.5841C219.509 24.5841 217.641 23.1848 216.707 22.2519C214.839 20.8527 213.905 18.5205 213.905 16.1884C213.905 13.3898 215.306 11.0577 216.707 10.1249C218.108 8.25915 219.976 7.79272 222.311 7.79272C223.712 7.79272 225.114 8.25915 226.515 9.192V11.9906Z",
    fill: "#2B2A29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.053 14.7892L239.592 8.25928H242.861L235.388 15.2557L242.861 24.1178H239.592L233.52 17.1214L233.053 17.5878V24.1178H230.718V8.25928H233.053V14.7892Z",
    fill: "#2B2A29"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.872 13.39L245.663 25.0506V8.25927H248.466V18.9871L259.208 7.32642V24.1178H256.872V13.39Z",
    fill: "#2B2A29"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.62 13.39L263.411 25.0506V8.25927H266.213V18.9871L276.955 7.32642V24.1178H274.62V13.39Z",
    fill: "#2B2A29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.689 41.8418L114.892 50.2375L118.628 41.8418H121.431L113.958 58.1667H111.623L113.491 53.036L107.886 41.8418H110.689Z",
    fill: "#2B2A29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.101 47.9053H132.64V41.8418H135.442V58.1667H132.64V50.2375H126.101V58.1667H123.299V41.8418H126.101V47.9053Z",
    fill: "#2B2A29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.854 46.9726L140.112 58.6333V41.8419H142.448V52.5697L153.656 41.3755V58.1668H150.854V46.9726Z",
    fill: "#2B2A29"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.195 41.8418C162.53 41.8418 163.464 42.3082 164.398 42.7746C164.865 43.2411 166.267 44.1739 166.267 46.5061C166.267 46.9725 165.8 48.3718 164.865 49.3046C166.734 49.771 167.668 51.1703 167.668 53.036C167.668 53.9689 167.201 55.8346 165.8 56.7674C164.398 58.1667 162.997 58.1667 161.596 58.1667H157.86V41.8418H160.195ZM160.195 48.8382H161.129C161.596 48.8382 163.931 48.8382 163.931 46.5061C163.931 44.6404 162.063 44.1739 161.129 44.1739H160.195V48.8382ZM160.195 55.8346H162.063C164.398 55.8346 164.865 54.4353 164.865 53.036C164.865 52.1032 164.398 50.7039 162.063 50.7039H160.195V55.8346Z",
    fill: "#2B2A29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.811 44.1739H173.739V47.9053H179.811V50.2375H173.739V55.8346H179.811V58.1667H170.937V41.8418H179.811V44.1739Z",
    fill: "#2B2A29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.75 41.8418C188.684 41.8418 190.085 41.8418 191.487 42.7746C192.421 43.7075 193.355 45.1068 193.355 46.5061C193.355 47.4389 192.888 48.8382 191.954 50.2375C190.552 51.1703 189.151 51.6367 187.75 51.6367H186.816V58.1667H184.014V41.8418H187.75ZM186.816 49.3046H187.75C190.085 49.3046 191.02 47.9053 191.02 46.5061C191.02 45.5732 190.552 44.1739 187.75 44.1739H186.816V49.3046Z",
    fill: "#2B2A29"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.3 45.5733C206.432 44.174 205.031 43.7076 204.097 43.7076C200.36 43.7076 198.025 46.5062 198.025 49.7712C198.025 53.5026 200.36 55.8347 204.097 55.8347C205.965 55.8347 207.366 54.9018 208.3 53.969V57.234C206.432 58.1668 205.031 58.1668 203.63 58.1668C200.827 58.1668 198.959 56.7675 198.025 56.3011C196.157 54.4354 195.69 52.1033 195.69 49.7712C195.69 46.9726 196.624 45.1069 198.025 43.7076C199.893 42.3083 201.761 41.3755 204.097 41.3755C205.498 41.3755 206.899 41.8419 208.3 42.7748V45.5733Z",
    fill: "#2B2A29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.311 46.9726L211.102 58.6333V41.8419H213.905V52.5697L224.646 41.3755V58.1668H222.311V46.9726Z",
    fill: "#2B2A29"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.987 44.1739V58.1667H231.652V44.1739H227.916V41.8418H237.724V44.1739H233.987Z",
    fill: "#2B2A29"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.867 44.1739H243.328V47.9053H249.4V50.2375H243.328V55.8346H249.867V58.1667H240.993V41.8418H249.867V44.1739Z",
    fill: "#2B2A29"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.273 44.1739V58.1667H255.938V44.1739H252.202V41.8418H262.01V44.1739H258.273Z",
    fill: "#2B2A29"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.09 75.4246C113.958 75.4246 114.892 75.891 115.826 76.3574C116.76 76.8238 117.694 77.7567 117.694 80.0888C117.694 81.0217 117.694 81.9545 116.293 82.8874C118.161 83.3538 119.095 85.2195 119.095 86.6188C119.095 87.5516 119.095 89.4173 117.694 90.3502C116.293 91.7495 114.892 91.7495 113.491 91.7495H109.755V75.4246H112.09ZM112.09 82.421H113.024C113.491 82.421 115.359 82.421 115.359 80.0888C115.359 78.2231 113.958 77.7567 113.024 77.7567H112.09V82.421ZM112.09 89.4173H113.491C116.293 89.4173 116.76 88.0181 116.76 87.0852C116.76 85.6859 116.293 84.2867 113.491 84.2867H112.09V89.4173Z",
    fill: "#2B2A29"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.711 79.156C136.843 77.7567 134.975 77.2903 134.041 77.2903C130.771 77.2903 128.436 80.0888 128.436 83.8202C128.436 87.0852 130.771 89.8838 134.041 89.8838C135.909 89.8838 137.777 88.4845 138.711 88.0181V90.8166C136.843 91.7495 134.975 91.7495 134.041 91.7495C131.239 91.7495 129.37 90.8166 128.436 89.8838C126.568 88.0181 125.634 86.1524 125.634 83.8202C125.634 80.5552 127.035 78.6895 128.436 77.2903C129.837 75.891 132.173 75.4246 134.041 75.4246C135.909 75.4246 137.31 75.4246 138.711 76.3574V79.156Z",
    fill: "#2B2A29"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.854 87.5516H144.316L142.448 91.7495H139.645L147.585 74.4917L155.525 91.7495H152.722L150.854 87.5516ZM149.92 85.2195L147.585 80.0888L145.25 85.2195H149.92Z",
    fill: "#2B2A29"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.728 81.9545H166.733V75.4246H169.536V91.7495H166.733V84.2867H159.728V91.7495H157.393V75.4246H159.728V81.9545Z",
    fill: "#2B2A29"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.541 81.9545L183.08 75.4246H186.349L178.876 82.8874L186.349 91.7495H183.08L177.008 84.2867L176.541 84.7531V91.7495H174.206V75.4246H176.541V81.9545Z",
    fill: "#2B2A29"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.822 77.7567V91.7495H191.487V77.7567H187.75V75.4246H197.558V77.7567H193.822Z",
    fill: "#2B2A29"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.575 75.4246V91.7495H216.24V77.7567H209.234V91.7495H206.899V75.4246H218.575Z",
    fill: "#2B2A29"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.586 77.7567H226.048V81.4881H232.119V83.8202H226.048V89.4173H232.586V91.7495H223.712V75.4246H232.586V77.7567Z",
    fill: "#2B2A29"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.993 77.7567V91.7495H238.658V77.7567H234.921V75.4246H244.729V77.7567H240.993Z",
    fill: "#2B2A29"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.872 77.7567H250.334V81.4881H256.872V83.8202H250.334V89.4173H256.872V91.7495H247.999V75.4246H256.872V77.7567Z",
    fill: "#2B2A29"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.812 75.4246C265.746 75.4246 267.147 75.4246 268.081 76.3574C269.482 77.2903 269.949 78.6895 269.949 80.0888C269.949 81.0217 269.949 82.8874 268.548 83.8202C267.147 84.7531 265.746 85.2195 264.812 85.2195H263.411V91.7495H261.076V75.4246H264.812ZM263.411 82.8874H264.812C266.68 82.8874 267.614 81.9545 267.614 80.0888C267.614 79.156 267.614 77.7567 264.812 77.7567H263.411V82.8874Z",
    fill: "#2B2A29"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.686 75.4246H281.625V77.7567H276.021V81.9545H277.889C278.823 81.9545 280.691 82.421 281.625 83.3538C282.56 84.2867 283.494 85.2195 283.494 87.0852C283.494 88.4845 282.56 89.8838 281.158 90.8166C280.224 91.7495 278.823 91.7495 277.889 91.7495H273.686V75.4246ZM276.021 89.4173H277.422C278.356 89.4173 280.691 89.4173 280.691 87.0852C280.691 85.6859 280.224 84.2867 277.889 84.2867H276.021V89.4173Z",
    fill: "#2B2A29"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.697 75.4246L291.9 83.8202L295.637 75.4246H297.972L290.966 91.7495H288.164L290.499 86.6188L284.428 75.4246H287.697Z",
    fill: "#2B2A29"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.576 75.4246C304.978 75.4246 305.912 75.4246 307.313 76.3574C308.714 77.2903 309.181 78.6895 309.181 80.0888C309.181 81.0217 309.181 82.8874 307.78 83.8202C306.379 84.7531 304.978 85.2195 303.576 85.2195H302.642V91.7495H300.307V75.4246H303.576ZM302.642 82.8874H303.576C305.912 82.8874 306.846 81.9545 306.846 80.0888C306.846 79.156 306.379 77.7567 303.576 77.7567H302.642V82.8874Z",
    fill: "#2B2A29"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.917 75.4246H320.857V77.7567H315.252V91.7495H312.917V75.4246Z",
    fill: "#2B2A29"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333 77.7567H326.461V81.4881H333V83.8202H326.461V89.4173H333V91.7495H324.126V75.4246H333V77.7567Z",
    fill: "#2B2A29"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1332 5.46069V93.6152H84.5344V5.46069H83.1332ZM26.6213 5.46069V24.1177C26.6213 24.1177 27.0884 24.1177 27.5554 24.1177V5.46069H26.6213ZM26.6213 39.0434V60.499C26.6213 61.4318 27.0884 61.8982 27.5554 62.3647V38.1105C27.0884 38.5769 26.6213 39.0434 26.6213 39.0434ZM26.6213 77.7567V93.6152H27.5554V78.2232C27.0884 77.7567 26.6213 77.7567 26.6213 77.7567ZM0 5.46069V93.6152H1.40112V5.46069H0ZM56.5119 5.46069V64.2304C56.979 63.7639 57.446 63.7639 57.913 63.2975V5.46069H56.5119ZM56.5119 78.6896V93.6152H57.913V78.2232C57.446 78.6896 57.446 78.6896 56.979 78.6896C56.979 78.6896 56.979 78.6896 56.5119 78.6896Z",
    fill: "#2B2A29"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3199 29.7149C66.3199 30.1813 66.7869 33.4463 67.254 36.7112C67.254 40.9091 67.254 46.0398 66.7869 49.7712C65.8528 54.9019 63.9847 60.0325 60.2483 63.764C56.045 68.4282 49.0394 70.2939 42.9678 70.2939C37.3634 70.2939 30.8248 68.4282 26.6214 64.2304C22.8851 60.499 21.484 54.9019 21.484 49.7712C21.484 46.5062 21.951 43.7076 22.8851 41.3755C25.2203 35.7784 29.8907 33.9127 35.0282 34.3791C37.8304 34.3791 42.5008 34.8455 44.369 36.7112C46.7042 39.5098 46.2371 44.6405 45.3031 47.439C45.3031 47.9055 44.836 49.3047 42.9678 49.7712C42.0338 49.7712 40.1656 49.3047 39.2315 49.3047C38.2974 48.8383 38.2974 48.3719 38.2974 47.9055C38.2974 46.0398 38.7645 45.1069 38.7645 43.7076C38.7645 43.2412 38.2974 42.7748 37.8304 42.3084C36.4293 41.8419 33.16 40.9091 31.2918 43.2412C30.8248 44.1741 29.8907 47.439 30.3577 49.3047C30.8248 52.1033 32.2259 53.969 33.627 54.9019C35.4952 56.3011 38.2974 56.7676 41.0997 57.234C44.369 57.234 47.6383 56.7676 49.5064 54.9019C53.2427 52.1033 54.1768 48.8383 54.6439 44.1741C55.1109 36.7112 51.8416 29.7149 44.369 26.9163C33.16 22.7185 19.1488 25.517 14.4784 37.6441C10.275 48.8383 11.6761 61.8982 20.0829 70.2939C28.9566 79.6224 44.836 81.4881 56.512 76.8239C64.9188 73.5589 70.5232 67.4954 73.3255 59.0997C75.1936 53.969 75.6607 48.8383 76.1277 43.7076C76.1277 41.3755 75.6607 39.0434 75.6607 36.7112C75.6607 34.8455 75.1936 32.5134 74.7266 31.1141C74.7266 30.1813 73.7925 30.1813 73.7925 29.7149L68.188 28.782C67.721 28.782 66.3199 28.782 66.3199 29.7149Z",
    fill: "#FFCE50"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.696 5.46065V8.72563L206.899 4.06137V0.796387L202.696 5.46065Z",
    fill: "#2B2A29"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.949 5.46065V8.72563L274.153 4.06137V0.796387L269.949 5.46065Z",
    fill: "#2B2A29"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.959 84.2866V87.5516L203.163 82.8873V79.6223L198.959 84.2866Z",
    fill: "#2B2A29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuLogoFooter);
export default __webpack_public_path__ + "static/media/eu-logo-footer.d8e5688589dc379036003c64f8b34571.svg";
export { ForwardRef as ReactComponent };